import { AbstractAppService } from "@shopliftr/common-ng";
import {
    inject, Injectable
} from "@angular/core";
import { APP_CONFIG } from "../constants/app-config-token";
import { AppRouterService } from "./app-router.service";
import { IAppConfig } from "../interfaces/app-config";

/**
 * The Application service manages the global state of the application.
 * For example processing or fullscreen
 *
 * This is provided in the app.options.ts for this application
 *
 * Can be injected directly in the application
 * ```
 * readonly appState = inject(AppService);
 * ```
 * @see AbstractAppService
 * @see IAppService
 */
@Injectable()
export class AppService extends AbstractAppService<IAppConfig, AppRouterService> {

    readonly config = inject(APP_CONFIG);
    readonly appRouter = inject(AppRouterService);
}
